import {v1_ContactBase} from '../../generated/types';

export const TransformDataForContactBase = (data: v1_ContactBase) => {
    const fullName = `${data.FirstName} ${data?.LastName || ''}`;
    return {
        ...data,
        FullName: fullName,
    };
};
